import { useClientSideAPIKey } from '@/util/url'
import { GiphyFetch } from '@giphy/js-fetch-api'
import { useMemo } from 'react'

export const useGiphyFetch = () => {
    const apiKey = useClientSideAPIKey()
    const gf = useMemo(() => {
        return new GiphyFetch(apiKey)
    }, [apiKey])
    return gf
}
